import { Call, CallStatus } from '@src/types/calls';
import { createEventBus } from '../../utils/createEventBus';

export type CallEvents = {
  [CallStatus.WAITING_ANSWER]: Call;
  [CallStatus.WAITING_AGENT]: Call;
  [CallStatus.MISSED]: Call;
  [CallStatus.FAILED]: Call;
  [CallStatus.REJECTED]: Call;
  [CallStatus.ONGOING]: Call;
  [CallStatus.TERMINATED]: Call;
};

export const callEventsBus = createEventBus<CallEvents>();
